module.exports = __webpack_public_path__ + "a6c15853cd94b033caf2405fa3c08c62.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/telesales/instacred.svg
// module id = SDbF
// module chunks = 458